var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationScribbleLightning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 143 139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.186 2c-25.48 23.38-50.96 46.76-76.439 70.066 17.472.871 34.87-1.743 52.124-4.284C42.89 89.855 24.981 111.927 7 134c9.9-2.541 18.564-8.277 26.936-14.013 32.54-22.363 63.845-46.469 94.566-71.3-12.012-.654-24.024-.146-35.963 1.452C107.317 38.304 121.804 26.106 136 13.617c-16.671-1.452-33.124-4.865-48.994-9.947"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationScribbleLightning);
export default __webpack_public_path__ + "static/media/illustration-scribble-lightning.7c6edbcb056781b00e39b1a869fdeb53.svg";
export { ForwardRef as ReactComponent };